import { createAction, props } from '@ngrx/store';
import { Order, OrderResponse } from '@b2b/features/order/utilities/order.model';

export const GET_ORDER = '[ORDER]: GET';
export const GET_ORDER_FAIL = '[ORDER]: GET FAIL';
export const GET_ORDER_SUCCESS = '[ORDER]: GET SUCCESS';

export const CREATE_ORDER = '[ORDER]: CREATE';
export const CREATE_ORDER_FAIL = '[ORDER]: CREATE FAIL';
export const CREATE_ORDER_SUCCESS = '[ORDER]: CREATE SUCCESS';

export const GET_ORDER_LIST = '[ORDER]: GET LIST';
export const GET_ORDER_LIST_FAIL = '[ORDER]: GET LIST FAIL';
export const GET_ORDER_LIST_SUCCESS = '[ORDER]: GET LIST SUCCESS';

export const createOrder = createAction(CREATE_ORDER);
export const createOrderSuccess = createAction(CREATE_ORDER_SUCCESS, props<{ data: OrderResponse[] }>());
export const createOrderFail = createAction(CREATE_ORDER_FAIL, props<{ message: string }>());

export const getOrder = createAction(GET_ORDER, props<{ code: string }>());
export const getOrderSuccess = createAction(GET_ORDER_SUCCESS, props<{ data: Order[] }>());
export const getOrderFail = createAction(GET_ORDER_FAIL, props<{ message: string }>());

export const getOrderList = createAction(
  GET_ORDER_LIST,
  props<{ b2bUnitUid: string; customerUid: string; page?: number }>(),
);
export const getOrderListSuccess = createAction(
  GET_ORDER_LIST_SUCCESS,
  props<{ data: OrderResponse[]; currentPage: number; totalPages: number }>(),
);
export const getOrderListFail = createAction(GET_ORDER_LIST_FAIL, props<{ message: string }>());
